import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path data-name="Path 3807" d="M24 12A12 12 0 1112 0a12 12 0 0112 12zm-3.6-4.8l-1.692-1.7L9.6 14.604l-4.308-4.3L3.6 12l6 6z" fill="#6c7778" /></svg>);